// WHAT: Hook für den Zugriff auf den HeaderContext
// WHY:  Auslagerung des Hooks in eigene Datei, damit die Context-Datei selbst nur Komponenten exportiert

import { useContext } from "react";

import { HeaderContext } from "./HeaderContext";

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error("useHeader must be used within a HeaderProvider");
  }
  return context;
};
